__webpack_require__.p = "/job-boards-analytics/referrals-hub/";